import { getEnrollmentHistoryUrl } from 'automation-ui-canvas/utils/urls';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { listBranchDebugPanelPath } from 'automation-ui-log-events/utils/routing/logEventsUrl';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const BranchDiagnosisButton = ({
  flowObjectTypeId,
  flowId,
  logEventIdempotencyId
}) => {
  const history = useHistory();
  const {
    search
  } = useLocation();
  return /*#__PURE__*/_jsx(TrackableButton, {
    size: "small",
    use: "tertiary",
    onClick: () => {
      history.replace({
        pathname: listBranchDebugPanelPath(getEnrollmentHistoryUrl({
          flowId
        }), logEventIdempotencyId),
        search
      });
    },
    trackableKey: Trackables.OPENED_DIAGNOSE_BRANCH_PANEL,
    marginBlockStart: "100",
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation.enrollmentHistory.panel.selected-enrollment.branchDiagnoseButton.title_cob",
      objectTypeId: flowObjectTypeId
    })
  });
};
export default BranchDiagnosisButton;